import React from 'react'
import PropTypes from 'prop-types'

// Outlined share-nodes glyph from the DS (Figma 724:7070); inlined because
// FontAwesome Free has no regular-weight share-nodes. Sizes with 1em and inherits
// The current text color.
const SHARE_NODES_PATH = 'M11.1997 8.23542C10.8264 8.23575 10.457 8.31327 10.1134 8.46336C9.76979 8.61345 9.'
  + '45898 8.83306 9.19942 9.10916L5.54458 7.13932C5.58018 6.95795 5.5984 6.77343 5.598'
  + '99 6.58839C5.59443 6.47942 5.58374 6.37081 5.56698 6.26311L9.0618 4.72149C9.48564 '
  + '5.2349 10.0717 5.5782 10.717 5.69111C11.3623 5.80402 12.0256 5.67932 12.5905 5.338'
  + '91C13.1553 4.99849 13.5856 4.46413 13.8058 3.82965C14.0259 3.19518 14.0218 2.50116'
  + ' 13.7943 1.86947C13.5667 1.23778 13.1302 0.7088 12.5613 0.375433C11.9925 0.0420662'
  + ' 11.3278 -0.0743788 10.6839 0.0465466C10.0399 0.167472 9.45796 0.518036 9.04018 1.'
  + '03668C8.62239 1.55532 8.39549 2.20888 8.39932 2.88259C8.4038 2.99294 8.41448 3.102'
  + '92 8.43133 3.21199L4.93731 4.74949C4.5749 4.3034 4.08962 3.98086 3.54548 3.82445C3'
  + '.00134 3.66803 2.42391 3.68508 1.88938 3.87335C1.35484 4.06161 0.888321 4.41224 0.'
  + '551357 4.87899C0.214392 5.34573 0.0228199 5.90665 0.00191415 6.48775C-0.0189916 7.'
  + '06885 0.131752 7.64282 0.434256 8.13393C0.73676 8.62505 1.17681 9.01023 1.69635 9.'
  + '23867C2.21589 9.46711 2.79052 9.52807 3.3444 9.4135C3.89829 9.29893 4.40542 9.0142'
  + '2 4.79889 8.59694L8.45213 10.5668C8.41706 10.7482 8.39938 10.9327 8.39932 11.1177C'
  + '8.39932 11.6878 8.56356 12.245 8.87126 12.719C9.17897 13.193 9.61632 13.5624 10.12'
  + '8 13.7806C10.6397 13.9988 11.2028 14.0558 11.746 13.9446C12.2892 13.8334 12.7882 1'
  + '3.5589 13.1798 13.1558C13.5714 12.7527 13.8381 12.2391 13.9462 11.68C14.0542 11.12'
  + '09 13.9988 10.5414 13.7868 10.0147C13.5749 9.48803 13.216 9.03788 12.7554 8.72117C'
  + '12.2949 8.40446 11.7535 8.23542 11.1997 8.23542V8.23542ZM11.1997 1.64732C11.437 1.'
  + '64732 11.6691 1.71977 11.8664 1.8555C12.0638 1.99124 12.2176 2.18416 12.3084 2.409'
  + '87C12.3993 2.63559 12.4231 2.88396 12.3767 3.12358C12.3304 3.3632 12.2161 3.5833 1'
  + '2.0483 3.75606C11.8804 3.92881 11.6666 4.04646 11.4338 4.09412C11.201 4.14179 10.9'
  + '597 4.11732 10.7404 4.02383C10.5211 3.93033 10.3336 3.77201 10.2018 3.56887C10.069'
  + '9 3.36573 9.99952 3.1269 9.99952 2.88259C9.99952 2.55498 10.126 2.24078 10.351 2.0'
  + '0912C10.5761 1.77747 10.8814 1.64732 11.1997 1.64732V1.64732ZM2.79865 7.82366C2.56'
  + '128 7.82366 2.32925 7.75121 2.13188 7.61548C1.93452 7.47975 1.78069 7.28682 1.6898'
  + '6 7.06111C1.59902 6.83539 1.57526 6.58702 1.62156 6.3474C1.66787 6.10779 1.78217 5'
  + '.88768 1.95002 5.71493C2.11786 5.54217 2.33171 5.42452 2.56451 5.37686C2.79732 5.3'
  + '292 3.03863 5.35366 3.25792 5.44715C3.47722 5.54065 3.66466 5.69898 3.79653 5.9021'
  + '2C3.92841 6.10525 3.99879 6.34408 3.99879 6.58839C3.99738 6.78265 3.95103 6.97376 '
  + '3.86358 7.14591C3.86358 7.15085 3.85638 7.15332 3.85397 7.15744V7.17062C3.75178 7.'
  + '36743 3.5997 7.53208 3.41389 7.64706C3.22807 7.76205 3.01546 7.82307 2.79865 7.823'
  + '66V7.82366ZM11.1997 12.353C10.8814 12.353 10.5761 12.2228 10.351 11.9912C10.126 11'
  + '.7595 9.99952 11.4453 9.99952 11.1177C10.0007 10.9259 10.0459 10.7371 10.1315 10.5'
  + '668C10.1315 10.5602 10.1403 10.5552 10.1443 10.5487V10.5355C10.2445 10.3426 10.392'
  + '6 10.1806 10.5735 10.0659C10.7544 9.95121 10.9617 9.88803 11.1741 9.8828C11.3865 9'
  + '.87756 11.5964 9.93046 11.7825 10.0361C11.9685 10.1417 12.124 10.2963 12.233 10.48'
  + '4C12.342 10.6717 12.4006 10.8859 12.4029 11.1045C12.4051 11.3232 12.351 11.5386 12'
  + '.2459 11.7287C12.1408 11.9187 11.9886 12.0767 11.8048 12.1864C11.6209 12.2961 11.4'
  + '121 12.3535 11.1997 12.353Z'

const ShareNodesIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 14 14"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={SHARE_NODES_PATH} fill="currentColor" />
  </svg>
)

ShareNodesIcon.propTypes = {
  className: PropTypes.string
}

ShareNodesIcon.defaultProps = {
  className: ''
}

export default ShareNodesIcon
